import { Browser } from "@capacitor/browser";

/** Custom URL scheme registered by the native app (matches the Capacitor appId). */
export const APP_SCHEME = "com.ikavio.app";
export const DEEP_LINK = `${APP_SCHEME}://auth`;

/** Path on the live site that bounces the Google session back into the app. */
export const bridgeUrl = () => `${process.env.REACT_APP_BACKEND_URL}/auth/native`;

/**
 * Google blocks OAuth inside embedded WebViews, so the native app opens the flow in the
 * system browser (SFSafariViewController / Chrome Custom Tabs) and gets the session back
 * through the app's deep link.
 */
export const startNativeGoogleLogin = async () => {
  const authUrl = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(bridgeUrl())}`;
  await Browser.open({ url: authUrl, presentationStyle: "popover" });
};

export const sessionIdFromUrl = (url) => {
  const m = (url || "").match(/session_id=([^&]+)/);
  return m ? decodeURIComponent(m[1]) : null;
};

export const closeAuthBrowser = () => Browser.close().catch(() => {});
